import React, { useState, useEffect, useMemo } from "react";
import { Space, Input, Radio, Dropdown, Menu, Modal } from "antd";
import {
	CloseCircleOutlined,
	PlusOutlined,
	QuestionCircleOutlined,
} from "@ant-design/icons";
import {
	ActionButton,
	AntdModal,
	AntdRadioButton,
	AvatarCell,
	EmailText,
	FilterContainer,
	Filters,
	Inner,
	NameText,
	RadioOptions,
	RoleTag,
	StatusText,
	UserAvatar,
	UserPhoto,
} from "./styles";
import {
	openNotificationWithIcon,
	TYPE,
} from "../../../../../utils/notificationToast";
import LoadingHeader from "./components/LoadingHeader";
import Image from "../../../../common/image/Image";
import { FaImages } from "react-icons/fa";
import { COLORS, Typo } from "../../../../layout/theme";
import DropShadow from "../../../../common/drop-shadow/DropShadow";
import SignInTemplate from "../../../../layout/sign-in-template/SignInTemplate";
import DataTable from "../../../../common/data-table/DataTable";
import {
	get_users_by_clientId,
	get_users_by_client_header_info,
	update_user_state,
} from "../../../../../api/endpoints/users";
import NoImageUser from "../../../.././../assets/images/SinImagenDeUsuario.jpeg";
import debounce from "lodash/debounce";
import { BsThreeDotsVertical } from "react-icons/bs";
import UpdateUser from "../update/UpdateUser";
import CreateUser from "../create/CreateUser";
import {
	checkRolPermission,
	setRolName,
} from "../../../../../utils/checkRolPermission";
import { Link, useNavigate } from "react-router-dom";
import AntdSearch from "../../../../common/antd-search/AntdSearch";

const { confirm } = Modal;

const ROLE_STYLES = {
	"Administrador General": {
		tagBg: COLORS.LightPrimary,
		tagColor: COLORS.Primary,
		avatarBg: COLORS.LightPrimary,
		avatarColor: COLORS.Primary,
	},
	"Administrador de Cuenta": {
		tagBg: COLORS.LightSecondary,
		tagColor: COLORS.Secondary,
		avatarBg: COLORS.LightSecondary,
		avatarColor: COLORS.Secondary,
	},
	Analista: {
		tagBg: COLORS.LightDefault,
		tagColor: COLORS.Default,
		avatarBg: COLORS.LightDefault,
		avatarColor: COLORS.Default,
	},
	Comprador: {
		tagBg: COLORS.LightSuccess,
		tagColor: COLORS.Success,
		avatarBg: COLORS.LightSuccess,
		avatarColor: COLORS.Success,
	},
	Dependiente: {
		tagBg: "#DCE8FF",
		tagColor: "#1D4ED8",
		avatarBg: "#DCE8FF",
		avatarColor: "#1D4ED8",
	},
	default: {
		tagBg: "#E5E7EB",
		tagColor: "#374151",
		avatarBg: "#E5E7EB",
		avatarColor: "#374151",
	},
};

const getRoleStyle = (role) => ROLE_STYLES[role] || ROLE_STYLES.default;

const getInitials = (firstName = "", lastName = "") => {
	const first = firstName?.trim()?.charAt(0) || "";
	const last = lastName?.trim()?.charAt(0) || "";
	return `${first}${last}`.toUpperCase();
};

export default function UsersList({
	clientId,
	client,
	userType,
	user,
	userdata,
	updateStartGuideProgress,
	guideProgress,
}) {
	const [headerInfo, setHeaderInfo] = useState(null);
	const [data, setData] = useState(null);
	const [state, setState] = useState("ACTIVE");
	const [key, setKey] = useState("null");
	const [userUpdated, setUserUpdated] = useState(false);
	const [showUpdateUserModal, setShowUpdateUserModal] = useState(false);
	const [showCreateUserModal, setShowCreateUserModal] = useState(false);
	const navigate = useNavigate();

	const handleUpdateUserClick = () => {
		if (data) setShowUpdateUserModal(true);
	};

	const handleCreateUserClick = () => {
		if (data) setShowCreateUserModal(true);
	};

	const handleOk = () => {
		setShowUpdateUserModal(false);
		setShowCreateUserModal(false);
	};

	const handleCancel = () => {
		setShowUpdateUserModal(false);
		setShowCreateUserModal(false);
	};

	const columns = [
		{
			title: "",
			dataIndex: "photoUrl",
			width: 70,
			render: (value, record) => {
				const roleStyle = getRoleStyle(record.rol);
				const initials = getInitials(record.firstName, record.lastName);

				return (
					<AvatarCell>
						{value ? (
							<UserPhoto
								src={value}
								alt={record.firstName ? record.firstName : "Usuario"}
							/>
						) : (
							<UserAvatar bg={roleStyle.avatarBg} color={roleStyle.avatarColor}>
								{initials}
							</UserAvatar>
						)}
					</AvatarCell>
				);
			},
		},
		{
			title: () => (
				<div style={{ color: COLORS.White, fontWeight: 700 }}>
					Nombre Completo
				</div>
			),
			dataIndex: "firstName",
			render: (value, record) => (
				<NameText
					onClick={handleUpdateUserClick}
					onMouseOver={() => setKey(record)}
				>
					{value} {record.lastName}
				</NameText>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.White, fontWeight: 700 }}>Email</div>
			),
			dataIndex: "email",
			render: (value) => <EmailText>{value}</EmailText>,
		},
		{
			title: () => (
				<div style={{ color: COLORS.White, fontWeight: 700 }}>Rol</div>
			),
			dataIndex: "rol",
			render: (value) => {
				const roleStyle = getRoleStyle(value);

				return (
					<RoleTag bg={roleStyle.tagBg} color={roleStyle.tagColor}>
						{value}
					</RoleTag>
				);
			},
		},
		{
			title: () => (
				<div style={{ color: COLORS.White, fontWeight: 700 }}>Estado</div>
			),
			dataIndex: "deleted",
			render: (value) => (
				<StatusText active={!value}>{value ? "Inactivo" : "Activo"}</StatusText>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.White, fontWeight: 700 }}>Acciones</div>
			),
			key: "id",
			dataIndex: "id",
			width: 70,
			render: (f, r) => (
				<Dropdown
					overlay={state === "ACTIVE" ? menuActive : menuDeleted}
					placement="bottomRight"
				>
					<ActionButton key={`${f}`} onMouseOver={() => setKey(r)}>
						<BsThreeDotsVertical />
					</ActionButton>
				</Dropdown>
			),
		},
	];

	const menuActive = (
		<Menu
			items={[
				{
					key: "1",
					label: (
						<Typo type="secondary" onClick={handleUpdateUserClick}>
							Editar
						</Typo>
					),
				},
				{
					key: "2",
					label: <Typo onClick={() => deleteUser(key?.id)}>Eliminar</Typo>,
				},
			]}
		/>
	);

	const menuDeleted = (
		<Menu
			items={[
				{
					key: "1",
					label: (
						<Typo type="secondary" onClick={handleUpdateUserClick}>
							Editar
						</Typo>
					),
				},
				{
					key: "2",
					label: <Typo onClick={() => activateUser(key?.id)}>Activar</Typo>,
				},
			]}
		/>
	);

	const fetch_users = async (search) => {
		const res = await get_users_by_clientId(search, clientId, userType);
		setData({
			items: res
				?.map((r) => ({
					...r,
					rol: setRolName(checkRolPermission(r, client)),
				}))
				.filter((c) => c.deleted === (state === "DELETED")),
		});
	};

	const fetch_users_header = async () => {
		const res = await get_users_by_client_header_info(clientId, userType);
		setHeaderInfo(res);
	};

	useEffect(() => {
		fetch_users_header();
	}, [state]);

	useEffect(() => {
		fetch_users("");
	}, [state, clientId, userUpdated]);

	useEffect(() => {
		return () => {
			debouncedEventHandler.cancel();
		};
	}, []);

	const eventHandler = (e) => {
		fetch_users(e.target.value);
	};

	const debouncedEventHandler = useMemo(() => debounce(eventHandler, 250), []);

	const deleteUser = (key) => {
		confirm({
			title: "¿Seguro que quiere eliminar el usuario?",
			icon: <CloseCircleOutlined style={{ color: "red" }} />,
			content: "El usuario se eliminara de inmediato",
			okText: "Sí",
			okType: "default",
			cancelText: "No",
			onOk: () => {
				handleAction(key, "DELETED");
			},
		});
	};

	const activateUser = (key) => {
		confirm({
			title: "¿Seguro que quiere activar el usuario?",
			icon: <CloseCircleOutlined style={{ color: "red" }} />,
			content: "El usuario se activara de inmediato",
			okText: "Sí",
			okType: "default",
			cancelText: "No",
			onOk: () => {
				handleAction(key, "ACTIVE");
			},
		});
	};

	const handleAction = async (key, state) => {
		try {
			const _state = { id: key, state: state };
			await update_user_state(_state);
			fetch_users("");
			fetch_users_header();
		} catch (err) {
			openNotificationWithIcon(
				TYPE.ERROR,
				"El usuario no se puede borrar",
				"El usuario no se puede borrar",
			);
		}
	};

	const handleRadioCheck = (e) => {
		setState(e.target.value);
	};

	const handleBackToTheGuide = () => {
		updateStartGuideProgress(user.uid, guideProgress);
		navigate("/startGuide");
	};

	return (
		<Inner>
			{!headerInfo ? (
				<LoadingHeader />
			) : (
				<FilterContainer>
					<AntdSearch
						width={400}
						allowClear
						placeholder="Buscar usuario"
						onChange={debouncedEventHandler}
						style={{ borderRadius: 15 }}
					/>
					{/* <DropShadow type="drop">
							<SignInTemplate.AntdButton
								type="primary"
								bg="Primary"
								color="White"
								icon={<PlusOutlined />}
								onClick={handleCreateUserClick}
								style={{ width: "200px", fontWeight: "400" }}
							>
								Crear usuario
							</SignInTemplate.AntdButton>
							<AntdModal
								title={`Crear Usuario Web de cuenta ${client.name}`}
								visible={showCreateUserModal}
								onOk={handleOk}
								onCancel={handleCancel}
								width={1200}
								centered={true}
								footer={false}
								destroyOnClose={true}
							>
								<CreateUser
									data={client.users[0]}
									client={client}
									checkCreated={setUserUpdated}
									closeCreateModal={setShowCreateUserModal}
									user={user}
									userdata={userdata}
									updateStartGuideProgress={updateStartGuideProgress}
									guideProgress={guideProgress}
								/>
							</AntdModal>
						</DropShadow> */}
					<RadioOptions>
						<Radio.Group value={state} onChange={handleRadioCheck}>
							<AntdRadioButton value="ACTIVE">
								Activo ({headerInfo?.totalActive})
							</AntdRadioButton>
							<AntdRadioButton value="DELETED">
								Inactivo ({headerInfo?.totalDisabled})
							</AntdRadioButton>
						</Radio.Group>
					</RadioOptions>
				</FilterContainer>
			)}
			<DataTable
				data={data}
				fetch={fetch_users}
				columns={columns}
				containerBackground={COLORS.White}
			/>
			{userdata?.guideProgress === 3 && (
				<SignInTemplate.AntdButton
					type="primary"
					bg="Primary"
					color="White"
					icon={<QuestionCircleOutlined />}
					onClick={handleBackToTheGuide}
					style={{ width: "250px", fontWeight: "400" }}
				>
					Volver a la Guia de Inicio
				</SignInTemplate.AntdButton>
			)}
			<AntdModal
				title={`Usuario: ${key?.firstName} ${key?.lastName}`}
				visible={showUpdateUserModal}
				onOk={handleOk}
				onCancel={handleCancel}
				width={1200}
				centered={true}
				footer={false}
				destroyOnClose={true}
			>
				<UpdateUser
					data={key}
					client={client}
					checkUpdated={setUserUpdated}
					closeUpdateModal={setShowUpdateUserModal}
				/>
			</AntdModal>
		</Inner>
	);
}
